// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AdditionalProperty } from '@shared/localizations/Resources';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
export class EventFormatter {
    static formattedData(events) {
        return events.map((event) => `${this.getFEvent(event)}`).join('\n');
    }
    static getFEvent(ev) {
        const formattedDateTime = DateTimeUtils.formatDate(ev.DateTime, 'DD.MM.YYYY HH:mm:ss.SSS');
        return ('->' +
            formattedDateTime +
            ' ' +
            this.typeStartTeg +
            this.typesStr[ev.EventType] +
            this.typeEndTeg +
            ' ' +
            this.sourceStartTeg +
            this.sourcesStr[ev.Source] +
            this.sourceEndTeg +
            ' ' +
            this.actionStartTeg +
            ev.Action +
            this.actionEndTeg +
            ' ' +
            this.textStartTeg +
            this.getFDescription(ev) +
            this.textEndTeg);
    }
    static getFDescription(ev) {
        let result = '';
        for (let i = 0; i < ev.DescriptionItems.length; i++) {
            const header = ev.DescriptionItems[i].Header.replace(`${AdditionalProperty}.`, '');
            let value = '';
            if (ev.DescriptionItems[i].Value != null) {
                if (ev.DescriptionItems[i].Value instanceof Date) {
                    value = DateTimeUtils.formatDate(ev.DescriptionItems[i].Value, 'DD.MM.YYYY HH:mm:ss.SSS');
                }
                else {
                    value = ev.DescriptionItems[i].Value.toString().replace(`${AdditionalProperty}.`, '');
                }
            }
            result += value ? `${header}:${value}; ` : header;
        }
        return result.trim();
    }
}
EventFormatter.typesStr = ['None', 'Information', 'Exception', 'Trading', 'System', 'Comment', 'Updater', 'Script'];
EventFormatter.sourcesStr = ['None', 'Out', 'MarginCall', 'Refused', 'In', 'RiskRuleWarning', 'Out'];
EventFormatter.typeStartTeg = '<typ>';
EventFormatter.typeEndTeg = '</typ>';
EventFormatter.sourceStartTeg = '<src>';
EventFormatter.sourceEndTeg = '</src>';
EventFormatter.actionStartTeg = '<act>';
EventFormatter.actionEndTeg = '</act>';
EventFormatter.textStartTeg = '<mes>';
EventFormatter.textEndTeg = '</mes>';
EventFormatter.idStartTeg = '<id>';
EventFormatter.idEndTeg = '</id>';
